import { useTokens } from "@gemini/core";
import { useMapboxToken } from "@/contexts/cdpConfig";
import { useLocation } from "@/location/hooks/useLocation";
export const useMapCard = () => {
    const { geometry } = useLocation() || {};
    const accessToken = useMapboxToken();
    const tokens = useTokens();
    const imageHeight = 300;
    const imageWidth = 900;
    const zoom = 15;
    const longitude = geometry === null || geometry === void 0 ? void 0 : geometry.coordinates[0];
    const latitude = geometry === null || geometry === void 0 ? void 0 : geometry.coordinates[1];
    const style = "streets-v12";
    const geoJSON = {
        geometry,
        type: "Feature",
        properties: {
            "marker-color": tokens["color.surface.brand.primary.default"],
            "marker-size": "medium",
            fill: tokens["color.content.status.information.default"],
            "fill-opacity": 0.3,
            "stroke-width": 2,
        },
    };
    const safeStringify = (obj) => {
        try {
            return JSON.stringify(obj);
        }
        catch (error) {
            if (error instanceof TypeError &&
                error.message.includes("circular structure")) {
                const seen = new WeakMap();
                return JSON.stringify(JSON.parse(JSON.stringify(obj, (_key, value) => typeof value === "object" && value !== null
                    ? seen.has(value)
                        ? "[Circular Reference]"
                        : seen.set(value, true) && value
                    : value)));
            }
            throw error;
        }
    };
    const urlEncodedGeoJSON = encodeURIComponent(safeStringify(geoJSON));
    const params = (geometry === null || geometry === void 0 ? void 0 : geometry.type) === "Point"
        ? `geojson(${urlEncodedGeoJSON})/${longitude},${latitude},${zoom}`
        : `geojson(${urlEncodedGeoJSON})/auto`;
    const mapPreviewUrl = `https://api.mapbox.com/styles/v1/mapbox/${style}/static/${params}/${imageWidth}x${imageHeight}?access_token=${accessToken}&attribution=false&logo=false`;
    return mapPreviewUrl;
};
